export function formatNumberWithThousandsSeparator(number: number) {
  return Math.abs(number).toString().length >= 5 ? number.toLocaleString('nl-NL') : number.toString();
}

export function calculateLevenshteinDistance<T>(a: T[], b: T[], equals: (x: T, y: T) => boolean = (x, y) => x === y): number {
  const m = a.length;
  const n = b.length;

  // Create matrix (m+1) x (n+1)
  const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));

  // Base cases
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;

  // Fill matrix
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = equals(a[i - 1], b[j - 1]) ? 0 : 1;

      dp[i][j] = Math.min(
        dp[i - 1][j] + 1, // deletion
        dp[i][j - 1] + 1, // insertion
        dp[i - 1][j - 1] + cost, // substitution
      );
    }
  }

  return dp[m][n];
}
